import styled from "@emotion/styled";
import { useAppDispatch } from "../../../hooks";
import ModalDialog, { ModalDialogButtons, ModalDialogResult } from "../elements/ModalDialog";
import t from "../../../helper/t";
import { closePrivacyPolicyDialog } from "../../../features/privacyPolicy/privacyPolicySlice";
import SmartLink from "../../../components/elements/SmartLink";
import { startMeasurement3 } from "../measurement/startMeasurement3";

const ContentContaner = styled.div([
    {
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
    }
]);

const PrivacyPolicyDialog: React.FC<{}> = () => {
    const dispatch = useAppDispatch();

    const onClose = (result: ModalDialogResult) => {
        dispatch(closePrivacyPolicyDialog(result === ModalDialogResult.StartSpeedtest));
        dispatch(startMeasurement3());
    }

    return (
        <ModalDialog header={t("Hinweis")} buttons={ModalDialogButtons.StartSpeedtest} onClose={onClose}>
            <ContentContaner>
                {t("Mit dem Klick auf den “Start”-Knopf bestätigst Du, dass Du die")}
                <br />
                <SmartLink href="/privacy_policy_faq" target="_blank" isNaked={false}>
                    {t("Bestimmungen zum Datenschutz")}
                </SmartLink>
                <br />
                {t("gelesen und akzeptiert hast und insbesondere in die Nutzung")}
                <br />
                {t("der im Rahmen der Messung erhobenen Daten einwilligst.")}
            </ContentContaner>
        </ModalDialog>
    );
}

export default PrivacyPolicyDialog;